query packagesFilter($scenarioId: ID!, $filterId: ID, $pagination: PaginationInput) {
  filter(scenarioId: $scenarioId) {
    packages(filterId: $filterId, pagination: $pagination) {
      items {
        id
        code
        index
        isPublished
        population {
          level
          curriculum
          term {
            code
          }
          campus {
            code
          }
          modality {
            code
          }
          shift {
            code
          }
          program {
            code
            name
          }
        }
        __typename
      }
      pageInfo {
        hasPreviousPage
        hasNextPage
        page
        size
        total
        __typename
      }
      __typename
    }
    __typename
  }
}
